import { usePlatformUpdate } from '@reapitform/hooks'
import { IDefaultSpecialTerms } from '../../types'

export const useDefaultSpecialConditionUpdate = () => {
  const path: string = '/api/Organization/DefaultSpecialCondition/'

  const [updateSpecialCondition, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<
    Omit<IDefaultSpecialTerms, 'lastUpdatedUTC'>,
    IDefaultSpecialTerms
  >({
    path: path,
    method: 'PUT',
    headers: {},
    errorMessage: 'Failed to update the template!',
    successMessage: 'Template successfully updated',
  })

  return { updateSpecialCondition, returnData, isLoading, isSuccess, isError }
}
